const APIReportRequest = {};

APIReportRequest["getAllTrainingsAttendedByFarmerIDAndDateRAnge"] = async (accessToken, farmerId, startDate, endDate) => {
	try {
		const response = await fetch(`/api/farmer-report/trainings-attended/${farmerId}/${startDate}/${endDate}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getAllClusterMembershipsByFarmerID"] = async (accessToken, farmerId) => {
	try {
		const response = await fetch(`/api/farmer-report/cluster-membership/${farmerId}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getAllIncomeByFarmerIDAndDateRAnge"] = async (accessToken, farmerId, startDate, endDate) => {
	try {
		const response = await fetch(`/api/farmer-report/income/${farmerId}/${startDate}/${endDate}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getAllFinancialTransactionsByFarmerIDAndDateRAnge"] = async (accessToken, farmerId, startDate, endDate) => {
	try {
		const response = await fetch(`/api/farmer-report/financial-transactions/${farmerId}/${startDate}/${endDate}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmerRegistrationSummaryBySiteId"] = async (accessToken, siteId) => {
	try {
		const response = await fetch(`/api/reports/farmer-registration/site/${siteId}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmerRegistrationSummaryByProvinceId"] = async (accessToken, provinceId) => {
	try {
		const response = await fetch(`/api/reports/farmer-registration/province/${provinceId}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmerRegistrationSummaryByRegionId"] = async (accessToken, regionId) => {
	try {
		const response = await fetch(`/api/reports/farmer-registration/region/${regionId}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getAllFarmerRegistrationSummary"] = async (accessToken) => {
	try {
		const response = await fetch('/api/reports/farmer-registration', {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}


APIReportRequest["getMembersByClusterId"] = async (accessToken, clid) => {
	try {
		const response = await fetch(`api/cluster-report/members/${clid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmerCommitmentsByClusterIdCropIdAndDate"] = async (accessToken, clid, crid, date) => {
	try {
		const response = await fetch(`api/reports/commitments/cluster/${clid}/crop/${crid}/date/${date}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getClusterCommitmentsBySiteIdCropIdAndDateRange"] = async (accessToken, sid, crid, start, end) => {
	try {
		const response = await fetch(`api/reports/commitments/per-cluster/site/${sid}/crop/${crid}/start-date/${start}/end-date/${end}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getClusterCommitmentsByProvinceIdCropIdAndDateRange"] = async (accessToken, pid, crid, start, end) => {
	try {
		const response = await fetch(`api/reports/commitments/per-cluster/province/${pid}/crop/${crid}/start-date/${start}/end-date/${end}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getSiteCommitmentsByProvinceIdCropIdAndDateRange"] = async (accessToken, pid, crid, start, end) => {
	try {
		const response = await fetch(`api/reports/commitments/per-site/province/${pid}/crop/${crid}/start-date/${start}/end-date/${end}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getProvinceCommitmentsByRegionIdCropIdAndDateRange"] = async (accessToken, rid, crid, start, end) => {
	try {
		const response = await fetch(`api/reports/commitments/per-province/region/${rid}/crop/${crid}/start-date/${start}/end-date/${end}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getProvinceCommitmentsByCropIdAndDateRange"] = async (accessToken, crid, start, end) => {
	try {
		const response = await fetch(`api/reports/commitments/per-province/crop/${crid}/start-date/${start}/end-date/${end}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getCollectiveMarketingByClusterIdCropIdAndDeliveryDate"] = async (accessToken, clid, crid, date) => {
	try {
		const response = await fetch(`api/reports/collective-marketing/cluster/${clid}/crop/${crid}/date/${date}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getCollectiveMarketingSummaryPerClusterBySiteIdandDateRange"] = async (accessToken, sid, start, end) => {
	try {
		const response = await fetch(`api/reports/collective-marketing/per-cluster/site/${sid}/start-date/${start}/end-date/${end}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getCollectiveMarketingSummaryPerClusterByProvinceIdandDateRange"] = async (accessToken, pid, start, end) => {
	try {
		const response = await fetch(`api/reports/collective-marketing/per-cluster/province/${pid}/start-date/${start}/end-date/${end}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getCollectiveMarketingSummaryPerSiteByProvinceIdandDateRange"] = async (accessToken, pid, start, end) => {
	try {
		const response = await fetch(`api/reports/collective-marketing/per-site/province/${pid}/start-date/${start}/end-date/${end}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getCollectiveMarketingSummaryPerSiteByRegionIdandDateRange"] = async (accessToken, rid, start, end) => {
	try {
		const response = await fetch(`api/reports/collective-marketing/per-site/region/${rid}/start-date/${start}/end-date/${end}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getCollectiveMarketingSummaryPerProvinceByRegionIdandDateRange"] = async (accessToken, rid, start, end) => {
	try {
		const response = await fetch(`api/reports/collective-marketing/per-province/region/${rid}/start-date/${start}/end-date/${end}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getCollectiveMarketingSummaryPerProvinceByDateRange"] = async (accessToken, start, end) => {
	try {
		const response = await fetch(`api/reports/collective-marketing/per-province/start-date/${start}/end-date/${end}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getCollectiveMarketingSummaryPerRegionByDateRange"] = async (accessToken, start, end) => {
	try {
		const response = await fetch(`api/reports/collective-marketing/per-region/start-date/${start}/end-date/${end}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmersInvolvedPerClusterByYearAndSiteId"] = async (accessToken, sid, year) => {
	try {
		const response = await fetch(`/api/reports/collective-marketing/farmer-involved/per-cluster/year/${year}/site/${sid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmersInvolvedPerSiteByYearAndProvinceId"] = async (accessToken, pid, year) => {
	try {
		const response = await fetch(`/api/reports/collective-marketing/farmer-involved/per-site/year/${year}/province/${pid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmersInvolvedPerProvinceByYearAndRegionId"] = async (accessToken, rid, year) => {
	try {
		const response = await fetch(`/api/reports/collective-marketing/farmer-involved/per-province/year/${year}/region/${rid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmersInvolvedPerSiteByYear"] = async (accessToken, year) => {
	try {
		const response = await fetch(`/api/reports/collective-marketing/farmer-involved/per-site/year/${year}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmersInvolvedPerProvinceByYear"] = async (accessToken, year) => {
	try {
		const response = await fetch(`/api/reports/collective-marketing/farmer-involved/per-province/year/${year}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}


APIReportRequest["getFarmersInvolvedPerRegionByYear"] = async (accessToken, year) => {
	try {
		const response = await fetch(`/api/reports/collective-marketing/farmer-involved/per-region/year/${year}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmerClusteringSummaryPerSiteBySiteId"] = async (accessToken, sid) => {
	try {
		const response = await fetch(`api/reports/farmer-clustering/per-site/site/${sid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmerClusteringSummaryPerSiteByProvinceId"] = async (accessToken, pid) => {
	try {
		const response = await fetch(`api/reports/farmer-clustering/per-site/province/${pid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmerClusteringSummaryPerProvinceByProvinceId"] = async (accessToken, pid) => {
	try {
		const response = await fetch(`api/reports/farmer-clustering/per-province/province/${pid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmerClusteringSummaryPerSiteByRegionId"] = async (accessToken, rid) => {
	try {
		const response = await fetch(`api/reports/farmer-clustering/per-site/region/${rid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmerClusteringSummaryPerProvinceByRegionId"] = async (accessToken, rid) => {
	try {
		const response = await fetch(`api/reports/farmer-clustering/per-province/region/${rid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmerClusteringSummaryPerRegionByRegionId"] = async (accessToken, rid) => {
	try {
		const response = await fetch(`api/reports/farmer-clustering/per-region/region/${rid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmerClusteringSummaryPerSite"] = async (accessToken, rid) => {
	try {
		const response = await fetch(`api/reports/farmer-clustering/per-site`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmerClusteringSummaryPerProvince"] = async (accessToken) => {
	try {
		const response = await fetch(`api/reports/farmer-clustering/per-province`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getFarmerClusteringSummaryPerRegion"] = async (accessToken) => {
	try {
		const response = await fetch(`api/reports/farmer-clustering/per-region`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getSWGSummaryPerSiteByProvinceId"] = async (accessToken, pid) => {
	try {
		const response = await fetch(`api/reports/swg/province/${pid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getSWGSummaryPerProvinceByRegionId"] = async (accessToken, pid) => {
	try {
		const response = await fetch(`api/reports/swg/region/${pid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getSWGSummaryPerProvince"] = async (accessToken) => {
	try {
		const response = await fetch(`api/reports/swg`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getOrganizationsBySiteId"] = async (accessToken, sid) => {
	try {
		const response = await fetch(`api/reports/organizations/site/${sid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getOrganizaionSummaryByProvinceId"] = async (accessToken, pid) => {
	try {
		const response = await fetch(`api/reports/organizations/province/${pid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getOrganizaionSummaryPerProvinceByRegionId"] = async (accessToken, rid) => {
	try {
		const response = await fetch(`api/reports/organizations/region/${rid}`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

APIReportRequest["getOrganizaionSummaryPerProvince"] = async (accessToken) => {
	try {
		const response = await fetch(`api/reports/organizations`, {
			method: 'GET', headers: {'Authorization': "Bearer " + accessToken}});
		if(!response.statusText) {
			throw Error(response.statusText);
		}
		const body = await response.json();
		return(body)
	}
	catch(error) {
		console.log(error);
		return(null);
	}
}

export default APIReportRequest
